import React, { useState, useEffect, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router";

import { Form, Formik, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { IoHelpCircle } from "react-icons/io5";

import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Tooltip,
  Icon,
  SimpleGrid,
  Checkbox,
  Box,
} from "@chakra-ui/react";

import CustomSelect from "../../../../components/CustomSelect";
import LoadingSpinner from "../../../../components/LoadingSpinner";

import RedeReferenciaSAService from "../../../../../main/services/RedeReferenciaSAService";
import EquipeSAService from "../../../../../main/services/EquipeSAService";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import Group from "../../Visualizar/Group";
import SemRegistros from "../../../../components/SemRegistros";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { scrollToFieldAnexo } from "../../../../utils/scrollToFIeldAnexo";
import { HINT_RESPONSAVEL_INFORMACOES } from "../../../../../helpers/hints";

const CadastrarRedeReferencia = () => {
  const { id } = useParams();
  const history = useHistory();
  const { setCadastrarRedeServ, idPJ } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const [conselhosTutelares, setConselhosTutelares] = useState({
    options: [],
    isLoading: false,
  });
  const [isLabelOpen, setIsLabelOpen] = useState(false);
  const [CREAS, setCREAS] = useState({ options: [], isLoading: false });
  const [CRAS, setCRAS] = useState({ options: [], isLoading: false });
  const [secretariasMunicipais, setSecretariasMunicipais] = useState({
    options: [],
    isLoading: false,
  });
  const [coordenadorias, setCoordenadorias] = useState({
    options: [],
    isLoading: false,
  });
  const [diretoriasRegionais, setDiretoriasRegionais] = useState({
    options: [],
    isLoading: false,
  });

  const [membros, setMembros] = useState({ options: [], isLoading: false });
  const [loading, setLoading] = useState(true);
  const [initialValues] = useState({
    conselhoTutelarId: "",
    creaId: "",
    crasId: "",
    ubs: "",
    cpas: "",
    naoSeAplicaCaps: [],
    capsi: "",
    naoSeAplicaCapsi: [],
    capsad: "",
    naoSeAplicaCapsad: [],
    secretariaMunicipalId: "",
    naoSeAplicaSecretariaMunicipalId: [],
    diretoriaRegionalId: "",
    coordenadoriaId: "",
    naoSeAplicaDiretoriaRegionalId: [],
    membroResponsavelId: "",
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idTipoPendencia, ref);
    },
    [idTipoPendencia],
  );

  useEffect(() => {
    RedeReferenciaSAService.getRedeReferenciaSA(id)
      .then((res) => {
        Swal.fire({
          title: "Atenção!",
          text: "Já existe uma Rede de Referência cadastrada para este Serviço de Acolhimento!",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push(
            `/servico-acolhimento/visualizar-rede-de-referencia/${id}`,
          );
        });
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.status !== 404) {
            Swal.fire({
              title: "Atenção!",
              text: "Já existe uma Rede de Referência cadastrada para este Serviço de Acolhimento!",
              icon: "warning",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            }).then(() => {
              history.push(
                `/servico-acolhimento/visualizar-rede-de-referencia/${id}`,
              );
            });
          } else {
            setLoading(false);
          }
        }
      });
  }, [history, id]);

  const handleGetConselhosTutelares = () => {
    setConselhosTutelares({ ...conselhosTutelares, isLoading: true });
    RedeReferenciaSAService.listarConselhosTutelares().then((res) => {
      setConselhosTutelares({ options: res.data, isLoading: false });
    });
  };

  const handleGetCREAS = () => {
    setCREAS({ ...CREAS, isLoading: true });
    RedeReferenciaSAService.listarCREAS().then((res) => {
      setCREAS({ options: res.data, isLoading: false });
    });
  };
  const handleGetCRAS = () => {
    setCRAS({ ...CRAS, isLoading: true });
    RedeReferenciaSAService.listarCRAS().then((res) => {
      setCRAS({ options: res.data, isLoading: false });
    });
  };
  const handleGetSecretariasMunicipais = () => {
    setSecretariasMunicipais({ ...secretariasMunicipais, isLoading: true });
    RedeReferenciaSAService.listarSecretariasMunicipais().then((res) => {
      setSecretariasMunicipais({ options: res.data, isLoading: false });
    });
  };
  const handleGetDiretoriasRegionais = () => {
    setDiretoriasRegionais({ ...diretoriasRegionais, isLoading: true });
    RedeReferenciaSAService.listarDiretoriasRegionais().then((res) => {
      setDiretoriasRegionais({ options: res.data, isLoading: false });
    });
  };
  const handleGetCoordenadorias = () => {
    setCoordenadorias({ ...coordenadorias, isLoading: true });
    RedeReferenciaSAService.listarCoordenadorias().then((res) => {
      setCoordenadorias({ options: res.data, isLoading: false });
    });
  };
  const handleGetMembros = () => {
    setMembros({ ...membros, isLoading: true });
    EquipeSAService.getEquipeSA(id).then((res) => {
      setMembros({ options: res.data, isLoading: false });
    });
  };

  const FocusClearField = () => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
      if (values.naoSeAplicaCaps.includes("Possui")) {
        setFieldValue("cpas", "");
      }
      if (values.naoSeAplicaCapsi.includes("Possui")) {
        setFieldValue("capsi", "");
      }

      if (values.naoSeAplicaCapsad.includes("Possui")) {
        setFieldValue("capsad", "");
      }

      if (values.naoSeAplicaSecretariaMunicipalId.includes("Possui")) {
        setFieldValue("secretariaMunicipalId", "");
      }

      if (values.naoSeAplicaDiretoriaRegionalId.includes("Possui")) {
        setFieldValue("diretoriaRegionalId", "");
      }
    }, [values, setFieldValue]);

    return null;
  };

  const schema = Yup.object().shape({
    conselhoTutelarId: Yup.mixed("Este campo é obrigatório!").required(
      "Este campo é obrigatório!",
    ),
    creaId: Yup.mixed("Este campo é obrigatório!").required(
      "Este campo é obrigatório!",
    ),
    crasId: Yup.mixed("Este campo é obrigatório!").required(
      "Este campo é obrigatório!",
    ),
    ubs: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    cpas: Yup.string("Este campo é obrigatório!").when("naoSeAplicaCaps", {
      is: (naoSeAplica) => !naoSeAplica.includes("Possui"),
      then: Yup.string("Este campo é obrigatório!")
        .required("Este campo é obrigatório!")
        .trim("Este campo é obrigatório!"),
    }),
    capsi: Yup.string("Este campo é obrigatório!").when("naoSeAplicaCapsi", {
      is: (naoSeAplica) => !naoSeAplica.includes("Possui"),
      then: Yup.string("Este campo é obrigatório!")
        .required("Este campo é obrigatório!")
        .trim("Este campo é obrigatório!"),
    }),
    capsad: Yup.string("Este campo é obrigatório!").when("naoSeAplicaCapsad", {
      is: (naoSeAplica) => !naoSeAplica.includes("Possui"),
      then: Yup.string("Este campo é obrigatório!")
        .required("Este campo é obrigatório!")
        .trim("Este campo é obrigatório!"),
    }),
    secretariaMunicipalId: Yup.mixed("Este campo é obrigatório!").when(
      "naoSeAplicaSecretariaMunicipalId",
      {
        is: (naoSeAplica) => !naoSeAplica.includes("Possui"),
        then: Yup.mixed("Este campo é obrigatório!").required(
          "Este campo é obrigatório!",
        ),
      },
    ),
    diretoriaRegionalId: Yup.mixed("Este campo é obrigatório!").when(
      "naoSeAplicaDiretoriaRegionalId",
      {
        is: (naoSeAplica) => !naoSeAplica.includes("Possui"),
        then: Yup.mixed("Este campo é obrigatório!").required(
          "Este campo é obrigatório!",
        ),
      },
    ),
    membroResponsavelId: Yup.mixed("Este campo é obrigatório!").required(
      "Este campo é obrigatório!",
    ),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        conselhoTutelarId,
        creaId,
        crasId,
        cpas,
        capsi,
        capsad,
        secretariaMunicipalId,
        coordenadoriaId,
        diretoriaRegionalId,
        membroResponsavelId,
        naoSeAplicaCaps,
        naoSeAplicaCapsi,
        naoSeAplicaCapsad,
        naoSeAplicaSecretariaMunicipalId,
        naoSeAplicaDiretoriaRegionalId,
        ...resto
      } = values;

      const valuesToSend = {
        servicoAcolhimentoId: id,
        conselhoTutelarId: conselhoTutelarId ? conselhoTutelarId.id : "",
        creaId: creaId ? creaId.id : "",
        crasId: crasId ? crasId.id : "",
        cpas: !naoSeAplicaCaps.includes("Possui") ? cpas.trim() : "",
        capsi: !naoSeAplicaCapsi.includes("Possui") ? capsi.trim() : "",
        capsad: !naoSeAplicaCapsad.includes("Possui") ? capsad.trim() : "",
        secretariaMunicipalId: !naoSeAplicaSecretariaMunicipalId.includes(
          "Possui",
        )
          ? secretariaMunicipalId
            ? secretariaMunicipalId.id
            : ""
          : "",
        coordenadoriaId:
          coordenadoriaId &&
          secretariaMunicipalId.nome.toUpperCase().includes("RIO DE JANEIRO") &&
          !naoSeAplicaSecretariaMunicipalId.includes("Possui")
            ? coordenadoriaId.id
            : "",
        diretoriaRegionalId: !naoSeAplicaDiretoriaRegionalId.includes("Possui")
          ? diretoriaRegionalId
            ? diretoriaRegionalId.id
            : ""
          : "",
        membroResponsavelId: membroResponsavelId ? membroResponsavelId.id : "",
        ...resto,
      };

      RedeReferenciaSAService.novaRedeReferenciaSA(valuesToSend)
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Registro cadastrado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            history.push(
              "/servico-acolhimento/visualizar-rede-de-referencia/" + id,
            );
            setCadastrarRedeServ(false);
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "redeReferencia") {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message
                      ? JSON.parse(error.response.data.message).redeReferencia
                      : "",
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  }).then(() => {});
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return roleKeycloack &&
    (roleKeycloack.includes(servicoAcolhimentoFunc.cadastrarRede) ||
      (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    !loading ? (
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(props) => (
          <Form>
            <FocusClearField />
            {setCadastrarRedeServ(hasFormChanged(initialValues, props.values))}
            <Box
              mt={"15px"}
              border={
                ["79"].includes(idTipoPendencia) ? "3px solid #4299E199" : ""
              }
            >
              <Group
                title="Rede de Referência do Serviço"
                mt={"0px"}
                scrollToField={
                  ["79"].includes(idTipoPendencia) ? scrollToField : null
                }
              >
                <>
                  <Box w={{ base: "100%", md: "60%" }} mt="15px">
                    <CustomSelectWField
                      fieldName="conselhoTutelarId"
                      label="Conselho Tutelar*"
                      placeholder="Selecione o Conselho Tutelar"
                      defaultValue={props.values.conselhoTutelarId || ""}
                      searchable={true}
                      getOptionLabel={(option) => option.nome}
                      getOptionValue={(option) => option.id}
                      autoload={false}
                      isLoading={conselhosTutelares.isLoading}
                      options={conselhosTutelares.options}
                      onChange={(value) => {
                        props.setFieldValue("conselhoTutelarId", value);
                      }}
                      onFocus={
                        conselhosTutelares.options.length === 0
                          ? handleGetConselhosTutelares
                          : null
                      }
                    />
                  </Box>
                  <Box w={{ base: "100%", md: "60%" }} mt="15px">
                    <CustomSelectWField
                      fieldName="creaId"
                      label="CREAS*"
                      placeholder="Selecione o CREAS"
                      defaultValue={props.values.creaId || ""}
                      searchable={true}
                      getOptionLabel={(option) => option.nome}
                      getOptionValue={(option) => option.id}
                      autoload={false}
                      isLoading={CREAS.isLoading}
                      options={CREAS.options}
                      onChange={(value) => {
                        props.setFieldValue("creaId", value);
                      }}
                      onFocus={
                        CREAS.options.length === 0 ? handleGetCREAS : null
                      }
                    />
                  </Box>
                  <Box w={{ base: "100%", md: "60%" }} mt="15px">
                    <CustomSelectWField
                      fieldName="crasId"
                      label="CRAS*"
                      placeholder="Selecione o CRAS"
                      defaultValue={props.values.crasId || ""}
                      searchable={true}
                      getOptionLabel={(option) => option.nome}
                      getOptionValue={(option) => option.id}
                      autoload={false}
                      isLoading={CRAS.isLoading}
                      options={CRAS.options}
                      onChange={(value) => {
                        props.setFieldValue("crasId", value);
                      }}
                      onFocus={CRAS.options.length === 0 ? handleGetCRAS : null}
                    />
                  </Box>
                  <Field name="ubs">
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={form.errors.ubs && form.touched.ubs}
                        id="ubs"
                        w={{ base: "100%", md: "60%" }}
                        mt="15px"
                      >
                        <FormLabel
                          color="#5F6377"
                          fontWeight="500"
                          fontSize="14px"
                          lineHeight="19.6px"
                          htmlFor="ubs"
                        >
                          UBS*
                        </FormLabel>
                        <Input
                          {...field}
                          h="42px"
                          name="ubs"
                          id="ubs"
                          backgroundColor="#fff"
                          autoComplete="off"
                          border="1px solid #D7D8DE"
                          placeholder="Informe a UBS"
                        />
                        <FormErrorMessage>{form.errors.ubs}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Flex
                    flexDir={{ base: "column", lg: "row" }}
                    mt="15px"
                    alignItems="flex-start"
                  >
                    <Field name="cpas">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={form.errors.cpas && form.touched.cpas}
                          id="cpas"
                          w={{ base: "100%", md: "60%" }}
                          mr="15px"
                        >
                          <FormLabel
                            color="#5F6377"
                            fontWeight="500"
                            fontSize="14px"
                            lineHeight="19.6px"
                            htmlFor="cpas"
                          >
                            CAPS*
                          </FormLabel>
                          <Input
                            {...field}
                            h="42px"
                            name="cpas"
                            id="cpas"
                            backgroundColor="#fff"
                            autoComplete="off"
                            border="1px solid #D7D8DE"
                            placeholder="Informe o CAPS"
                            isDisabled={props.values.naoSeAplicaCaps.includes(
                              "Possui",
                            )}
                          />
                          <FormErrorMessage>
                            {form.errors.cpas}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="naoSeAplicaCaps">
                      {({ field, form }) => (
                        <FormControl
                          id="naoSeAplicaCaps"
                          mt={{
                            base: "15px !important",
                            lg: "35px !important",
                          }}
                          width="max-content"
                        >
                          <Checkbox
                            {...field}
                            value="Possui"
                            name="naoSeAplicaCaps"
                            id="naoSeAplicaCaps"
                            whiteSpace="nowrap"
                          >
                            Não se aplica
                          </Checkbox>
                          <FormErrorMessage>
                            {form.errors.naoSeAplicaCaps}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Flex>
                  <Flex
                    flexDir={{ base: "column", lg: "row" }}
                    mt="15px"
                    alignItems="flex-start"
                  >
                    <Field name="capsi">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={form.errors.capsi && form.touched.capsi}
                          id="capsi"
                          w={{ base: "100%", md: "60%" }}
                          mr="15px"
                        >
                          <FormLabel
                            color="#5F6377"
                            fontWeight="500"
                            fontSize="14px"
                            lineHeight="19.6px"
                            htmlFor="capsi"
                          >
                            CAPSi*
                          </FormLabel>
                          <Input
                            {...field}
                            h="42px"
                            name="capsi"
                            id="capsi"
                            backgroundColor="#fff"
                            autoComplete="off"
                            border="1px solid #D7D8DE"
                            placeholder="Informe o CAPSi"
                            isDisabled={props.values.naoSeAplicaCapsi.includes(
                              "Possui",
                            )}
                          />
                          <FormErrorMessage>
                            {form.errors.capsi}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="naoSeAplicaCapsi">
                      {({ field, form }) => (
                        <FormControl
                          id="naoSeAplicaCapsi"
                          mt={{
                            base: "15px !important",
                            lg: "35px !important",
                          }}
                          width="max-content"
                        >
                          <Checkbox
                            {...field}
                            value="Possui"
                            name="naoSeAplicaCapsi"
                            id="naoSeAplicaCapsi"
                            whiteSpace="nowrap"
                          >
                            Não se aplica
                          </Checkbox>
                          <FormErrorMessage>
                            {form.errors.naoSeAplicaCapsi}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Flex>
                  <Flex
                    flexDir={{ base: "column", lg: "row" }}
                    mt="15px"
                    alignItems="flex-start"
                  >
                    <Field name="capsad">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={form.errors.capsad && form.touched.capsad}
                          id="capsad"
                          w={{ base: "100%", md: "60%" }}
                          mr="15px"
                        >
                          <FormLabel
                            color="#5F6377"
                            fontWeight="500"
                            fontSize="14px"
                            lineHeight="19.6px"
                            htmlFor="capsad"
                          >
                            CAPSad*
                          </FormLabel>
                          <Input
                            {...field}
                            h="42px"
                            name="capsad"
                            id="capsad"
                            backgroundColor="#fff"
                            autoComplete="off"
                            border="1px solid #D7D8DE"
                            placeholder="Informe o CAPSad"
                            isDisabled={props.values.naoSeAplicaCapsad.includes(
                              "Possui",
                            )}
                          />
                          <FormErrorMessage>
                            {form.errors.capsad}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="naoSeAplicaCapsad">
                      {({ field, form }) => (
                        <FormControl
                          id="naoSeAplicaCapsad"
                          mt={{
                            base: "15px !important",
                            lg: "35px !important",
                          }}
                          w="max-content"
                        >
                          <Checkbox
                            {...field}
                            value="Possui"
                            name="naoSeAplicaCapsad"
                            id="naoSeAplicaCapsad"
                            whiteSpace="nowrap"
                          >
                            Não se aplica
                          </Checkbox>
                          <FormErrorMessage>
                            {form.errors.naoSeAplicaCapsad}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Flex>
                  <Flex
                    flexDir={{ base: "column", lg: "row" }}
                    mt="15px"
                    alignItems="flex-start"
                  >
                    <Box w={{ base: "100%", md: "60%" }} mr="15px">
                      <CustomSelectWField
                        fieldName="secretariaMunicipalId"
                        label="Secretaria Municipal de Educação*"
                        placeholder="Selecione a Secretaria"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        defaultValue={props.values.secretariaMunicipalId || ""}
                        isLoading={secretariasMunicipais.isLoading}
                        options={secretariasMunicipais.options}
                        searchable={true}
                        autoload={false}
                        isDisabled={props.values.naoSeAplicaSecretariaMunicipalId.includes(
                          "Possui",
                        )}
                        onChange={(value) => {
                          props.setFieldValue("secretariaMunicipalId", value);
                        }}
                        onFocus={
                          secretariasMunicipais.options.length === 0
                            ? handleGetSecretariasMunicipais
                            : null
                        }
                      />
                    </Box>
                    <Field name="naoSeAplicaSecretariaMunicipalId">
                      {({ field, form }) => (
                        <FormControl
                          id="naoSeAplicaSecretariaMunicipalId"
                          mt={{
                            base: "15px !important",
                            lg: "35px !important",
                          }}
                          w="max-content"
                        >
                          <Checkbox
                            {...field}
                            value="Possui"
                            name="naoSeAplicaSecretariaMunicipalId"
                            id="naoSeAplicaSecretariaMunicipalId"
                            whiteSpace="nowrap"
                          >
                            Não se aplica
                          </Checkbox>
                          <FormErrorMessage>
                            {form.errors.naoSeAplicaSecretariaMunicipalId}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Flex>
                  {(props.values.secretariaMunicipalId &&
                  !props.values.naoSeAplicaSecretariaMunicipalId.includes(
                    "Possui",
                  )
                    ? props.values.secretariaMunicipalId.nome
                        .toUpperCase()
                        .includes("RIO DE JANEIRO")
                    : false) && (
                    <Flex flexDir="row" mt="15px" alignItems="flex-start">
                      <Field name="coordenadoriaId">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={
                              form.errors.coordenadoriaId &&
                              form.touched.coordenadoriaId
                            }
                            id="coordenadoriaId"
                            w={{ base: "100%", md: "60%" }}
                            mr="15px"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor="coordenadoriaId"
                            >
                              Coordenadoria Regional de Educação
                            </FormLabel>
                            <CustomSelect
                              isInvalid={
                                form.errors.coordenadoriaId &&
                                form.touched.coordenadoriaId
                              }
                              value={props.values.coordenadoriaId || ""}
                              searchable={true}
                              isClearable={true}
                              getOptionLabel={(option) => option.nome}
                              getOptionValue={(option) => option.id}
                              autoload={false}
                              isLoading={coordenadorias.isLoading}
                              options={coordenadorias.options}
                              placeholder="Selecione a Coordenadoria"
                              onChange={(value) => {
                                props.setFieldValue("coordenadoriaId", value);
                              }}
                              onFocus={
                                coordenadorias.options.length === 0
                                  ? handleGetCoordenadorias
                                  : null
                              }
                            />
                            <FormErrorMessage>
                              {form.errors.coordenadoriaId}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Flex>
                  )}
                  <Flex
                    flexDir={{ base: "column", lg: "row" }}
                    mt="15px"
                    alignItems="flex-start"
                  >
                    <Box w={{ base: "100%", md: "60%" }} mr="15px">
                      <CustomSelectWField
                        fieldName="diretoriaRegionalId"
                        label="Coordenadoria Educacional/Diretoria Regional
                            Estadual*"
                        placeholder="Selecione a Coordenadoria"
                        searchable={true}
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        defaultValue={props.values.diretoriaRegionalId || ""}
                        autoload={false}
                        isLoading={diretoriasRegionais.isLoading}
                        options={diretoriasRegionais.options}
                        isDisabled={props.values.naoSeAplicaDiretoriaRegionalId.includes(
                          "Possui",
                        )}
                        onChange={(value) => {
                          props.setFieldValue("diretoriaRegionalId", value);
                        }}
                        onFocus={
                          diretoriasRegionais.options.length === 0
                            ? handleGetDiretoriasRegionais
                            : null
                        }
                      />
                    </Box>
                    <Field name="naoSeAplicaDiretoriaRegionalId">
                      {({ field, form }) => (
                        <FormControl
                          id="naoSeAplicaDiretoriaRegionalId"
                          mt={{
                            base: "15px !important",
                            lg: "35px !important",
                          }}
                          w="max-content"
                        >
                          <Checkbox
                            {...field}
                            value="Possui"
                            name="naoSeAplicaDiretoriaRegionalId"
                            id="naoSeAplicaDiretoriaRegionalId"
                            whiteSpace="nowrap"
                          >
                            Não se aplica
                          </Checkbox>
                          <FormErrorMessage>
                            {form.errors.naoSeAplicaDiretoriaRegionalId}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Flex>
                </>
              </Group>
              <Group
                title="RESPONSÁVEL PELAS INFORMAÇÕES:"
                mt={"20px"}
                position={"relative"}
              >
                <Tooltip
                  label={HINT_RESPONSAVEL_INFORMACOES}
                  fontSize="md"
                  isOpen={isLabelOpen}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: "25px",
                      left: "330px",
                    }}
                  >
                    <Icon
                      aria-label="Ajuda"
                      color="#6B6C71"
                      as={IoHelpCircle}
                      boxSize="20px"
                      onMouseEnter={() => setIsLabelOpen(true)}
                      onMouseLeave={() => setIsLabelOpen(false)}
                      onClick={() => setIsLabelOpen(true)}
                    />
                  </span>
                </Tooltip>

                <SimpleGrid
                  columns={{ base: 1, lg: 2 }}
                  spacing="15px"
                  mt="10px"
                >
                  <CustomSelectWField
                    fieldName="membroResponsavelId"
                    label="Nome*"
                    placeholder="Selecione o Nome"
                    searchable={true}
                    defaultValue={props.values.membroResponsavelId || ""}
                    getOptionLabel={(option) => option.nome}
                    getOptionValue={(option) => option.id}
                    autoload={false}
                    isLoading={membros.isLoading}
                    options={membros.options}
                    onChange={(value) => {
                      props.setFieldValue("membroResponsavelId", value);
                    }}
                    onFocus={
                      membros.options.length === 0 ? handleGetMembros : null
                    }
                  />
                  <FormControl id="funcao">
                    <FormLabel
                      color="#5F6377"
                      fontWeight="500"
                      fontSize="14px"
                      lineHeight="19.6px"
                      htmlFor="funcao"
                    >
                      Função/Cargo
                    </FormLabel>
                    <Input
                      value={
                        props.values.membroResponsavelId
                          ? props.values.membroResponsavelId
                              .tipoEquipeAcolhimento.nomeEquipe ===
                            "Equipe de Referência"
                            ? props.values.membroResponsavelId
                                .funcaoEquipeAcolhimento
                              ? props.values.membroResponsavelId
                                  .funcaoEquipeAcolhimento.nomeFuncao
                              : ""
                            : props.values.membroResponsavelId
                                .cargoEquipeAcolhimento
                            ? props.values.membroResponsavelId
                                .cargoEquipeAcolhimento.nomeCargo
                            : ""
                          : ""
                      }
                      isDisabled={true}
                      h="42px"
                      name="funcao"
                      id="funcao"
                      backgroundColor="#fff"
                      autoComplete="off"
                      border="1px solid #D7D8DE"
                      placeholder="Selecione o nome"
                    />
                  </FormControl>
                </SimpleGrid>
              </Group>
            </Box>
            <Flex mt="20px" justifyContent="flex-end">
              <Button
                id="button-salvar"
                type="submit"
                translate="no"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                w="17%"
                isLoading={props.isSubmitting}
              >
                Salvar
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt="2">
      <SemRegistros half buttonVisible={true} />
    </Box>
  );
};

export default CadastrarRedeReferencia;
